import * as T from 'three';
import { SVD } from 'svd-js';
import { transposeMatrix } from '../helpers';

export function getBestPlane(points) {
    let matrix = []
    let averagePoint = new T.Vector3(0, 0, 0)
    for(let i = 0; i < points.length; i+=1) {
        averagePoint.add(points[i])
        matrix.push([points[i].x, points[i].y, points[i].z])
    }
    averagePoint.divideScalar(matrix.length)

    for(let i = 0; i < matrix.length; i++) {
        matrix[i][0] -= averagePoint.x;
        matrix[i][1] -= averagePoint.y;
        matrix[i][2] -= averagePoint.z;
    }
    
    let { u, v, q } = SVD(matrix, 'f')

    let index = 0;
    let min = 1000
    for(let i = 0; i < 3; i++) {
        if(q[i] < min) {
            min = q[i]
            index = i
        }
    }
    let n = transposeMatrix(v)[index]
    let normal = new T.Vector3(n[0], n[1], n[2])
    return {
        point: averagePoint,
        normal: normal
    }
}

export class Plane {
    constructor(scene, point, normal, color = "red") {
        this.scene = scene
        this.point = point
        this.normal = normal

        this.planeGroup = new T.Group()
        let centerBall = new T.Mesh(new T.SphereGeometry(0.02),  new T.MeshStandardMaterial({color: "white"}))
        // centerBall.position.set(point.x, point.y, point.z)
        let planeMesh = new T.Mesh( new T.PlaneGeometry( 1, 1 ),  
            new T.MeshStandardMaterial({color: color, side: T.DoubleSide, transparent: true, opacity: 0.2}));

        this.planeGroup.add(centerBall)
        this.planeGroup.add(planeMesh)

        this.planeGroup.position.set(point.x, point.y, point.z)
        this.planeGroup.lookAt(point.x + normal.x, point.y + normal.y, point.z + normal.z)

        this.scene.add(this.planeGroup);
        this.planeGroup.visible = false
    }

    updatePlane(point, normal) {
        this.point.copy(point)
        this.normal.copy(normal)
        this.planeGroup.position.set(point.x, point.y, point.z)
        this.planeGroup.lookAt(point.x + normal.x, point.y + normal.y, point.z + normal.z)
    }

    deletePlane() {
        this.scene.remove(this.planeGroup)
    }

    setVisible(show) {
        this.planeGroup.visible = show
    }
}